import type { TableConfigurationDto } from 'cadenza/result-table/table-configuration-dto';
import { assert } from 'cadenza/utils/custom-error';
import type { ResultTable } from 'cadenza/result-table/result-table';
import { BaseTablePlugin } from 'cadenza/ui/base-table/base-table-plugin';

export abstract class ResultTablePlugin extends BaseTablePlugin {

  /**
   * Called whenever the configuration of the ResultTable has changed.
   * @param {TableConfigurationDto} tableConfiguration - the configuration of the ResultTable
   */
  configureWithConfigurationData (tableConfiguration: TableConfigurationDto) {
    // Does nothing by default
  }

  override get table () {
    const resultTable = this.parentElement;
    assert(resultTable, 'Plugin not yet initialized by result table');
    return resultTable as ResultTable;
  }

}
